export default "__VITE_ASSET__8gxDQz86__"